import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenAutoShipCartConnector } from '../features/auto-ship/core/connectors/auto-ship-cart.connector';

@Injectable()
export class GenAutoShipShipmentScheduleService {
  static readonly CART_ID = 'autoship';
 
  constructor(
    private connector: GenAutoShipCartConnector
  ) { }

  scheduleShipment(
    userId: string,
    shipmentDates: string[],
  ): Observable<unknown> {
    return this.connector.scheduleShipment(
      userId,
      GenAutoShipShipmentScheduleService.CART_ID,
      { shipmentDates },
    );
  }
}
